import type { FC, ReactNode } from 'react'

// SVG filters used by the .duotone-* classes: shadows take the first colour, highlights the second.
export const DuotoneFilters: FC = (): ReactNode => {
    return (
        <svg
            aria-hidden='true'
            focusable='false'
            width='0'
            height='0'
            className='pointer-events-none absolute'
        >
            <defs>
                <filter id='duotone-night' colorInterpolationFilters='sRGB'>
                    <feColorMatrix
                        type='matrix'
                        values='0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0'
                    />
                    <feComponentTransfer>
                        <feFuncR type='table' tableValues='0.114 0.894' />
                        <feFuncG type='table' tableValues='0.031 0.835' />
                        <feFuncB type='table' tableValues='0.220 0.588' />
                    </feComponentTransfer>
                </filter>

                <filter id='duotone-lilac' colorInterpolationFilters='sRGB'>
                    <feColorMatrix
                        type='matrix'
                        values='0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0'
                    />
                    <feComponentTransfer>
                        <feFuncR type='table' tableValues='0.165 0.776' />
                        <feFuncG type='table' tableValues='0.039 0.725' />
                        <feFuncB type='table' tableValues='0.302 0.886' />
                    </feComponentTransfer>
                </filter>
            </defs>
        </svg>
    )
}
